import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const WizardProgress = ({ currentStep, totalSteps, steps, onExit }) => {
  const navigate = useNavigate();

  const handleExit = () => {
    if (onExit) {
      onExit();
    } else {
      navigate('/');
    }
  };

  return (
    <div className="w-full mb-8 md:mb-10 lg:mb-12">
      <div className="flex items-center justify-between mb-4 md:mb-6">
        {steps?.map((step, index) => {
          const stepNumber = index + 1;
          const isCompleted = stepNumber < currentStep;
          const isCurrent = stepNumber === currentStep;
          const isUpcoming = stepNumber > currentStep;

          return (
            <React.Fragment key={step?.id}>
              <div className="flex flex-col items-center flex-1">
                <div
                  className={`flex items-center justify-center w-10 h-10 md:w-12 md:h-12 lg:w-14 lg:h-14 rounded-full font-semibold transition-smooth ${
                    isCompleted
                      ? 'bg-success text-success-foreground'
                      : isCurrent
                      ? 'bg-accent text-accent-foreground'
                      : 'bg-muted text-muted-foreground'
                  }`}
                >
                  {isCompleted ? (
                    <Icon name="Check" size={20} />
                  ) : (
                    <span className="text-sm md:text-base lg:text-lg">{stepNumber}</span>
                  )}
                </div>
                <p
                  className={`mt-2 text-xs md:text-sm lg:text-base font-medium text-center transition-smooth ${
                    isCurrent ? 'text-foreground' : 'text-muted-foreground'
                  }`}
                >
                  {step?.title}
                </p>
              </div>
              {index < steps?.length - 1 && (
                <div className="flex-1 mx-2 md:mx-4">
                  <div
                    className={`h-1 rounded-full transition-smooth ${
                      isCompleted ? 'bg-success' : 'bg-muted'
                    }`}
                  />
                </div>
              )}
            </React.Fragment>
          );
        })}
      </div>
      <div className="flex items-center justify-between">
        <p className="text-sm md:text-base text-muted-foreground font-caption">
          Step {currentStep} of {totalSteps}
        </p>
        <button
          onClick={handleExit}
          className="flex items-center gap-1.5 text-sm text-muted-foreground hover:text-foreground transition-colors"
        >
          <Icon name="X" size={14} />
          Exit setup
        </button>
      </div>
    </div>
  );
};

export default WizardProgress;